module.exports = __webpack_public_path__ + "img/fish5.39bd9b0d.png";